import { SET_SHAREABLE_URL } from './../const';

export default (shareableUrl) => {
    return {
      type: SET_SHAREABLE_URL,
      shareableUrl: shareableUrl
    }
};